import { Component, OnInit, Input, ContentChildren, TemplateRef} from "@angular/core";


export interface Popover{
  fieldId: string;
  fieldTitle: string;
  tabs: {
    helptext?:string;
    history?: History[];
  }
}



export interface History{
  Id: string;
  Value: string;
  User: string;
  Date: string;
}

@Component({
  selector: 'crem-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  // Upon component consumption, the below data object will be your only required Input, structured by the data types popover and history interfaces above
  @Input() popover : Popover;
  @Input() id: string;

  color = 'gray';
  type = "text";

  disabled = false;
  icon = 'fas fa-info-circle';
  withAnimationOptionsVisible: boolean;
  constructor() {
    this.withAnimationOptionsVisible = false;
  }

  ToggleAnimationOptions() {
    this.withAnimationOptionsVisible = !this.withAnimationOptionsVisible;
  }

  // selectTab(e) {
  //   return this.tabs.content;
  // }
}
